/**
 * @desc 创建更新ECN变更外发
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmBomAddOutGoingRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/outgoing/addOutgoing`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
